<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.vacations')"
                :pgIcon="'bx bx-bed'"
                :refs="refs"
                :addNew="addNew">
            </Breadcrumb>


            <DataTable
                :refs="refs"
                :colspan=7

                :hasHashId=true
                :hasMultiSelect=false
                :hasBulkAction=true
                :HasExport=true
                :hasShowEntries=true
                :hasFilterByDate="true"

                :fields="{
                    'id': 'id',
                    'date': 'date',
                    'employee_name': 'employee_name',
                    'start_date': 'start_date',
                    'end_date' : 'end_date',
                    'days' : 'days',
                    'subject' : 'subject',
                    'details' : 'details'
                }"

                :hasImage=true
                :redirectToEmployee=true
                :image="$t('view.employee_name')"
                :image_style="'width: 40px;height: 40px;border-radius: 50%;margin-top:-5px'"

                :hasTitle=true
                :title="$t('view.vacation_name')"

                :hasStartDate=true
                :hasEndDate=true
                
                :hasFilterByEndDate=true

                :hasDate=false
                :hasStatus=true
                :hasActions=true

                :actionable=true
                :sorDataTable=true

                v-on:hasAddNewPermission="handlePermissoinChange">
            </DataTable>

        </div>
    </div>

</template>

<script>
export default {
    name: 'List',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        DataTable: () => import('@/components/DataTable.vue')
    },
    data(){
        return {    
            //
            addNew: false,
            refs: 'vacations',
        }
    },
    watch: {
        //
    },
    mounted() {
        //
    },
    created() {
        //
    },
    methods: {
        handlePermissoinChange(event) {
            this.addNew = event;
        },
    },
}
</script>
